module.exports = __webpack_public_path__ + "img/user.1abe9241.svg";